import axios from 'axios';
import axiosInstance from './axiosInstance';

const API_URL = 'https://trueface.co.in/auth/login';
const VERIFY_OTP_URL = 'https://trueface.co.in/auth/verify-otp';
const REFRESH_URL = 'https://trueface.co.in/auth/refresh-token';
const VALIDATE_URL = 'https://trueface.co.in/auth/validate-token';

// Step 1: Send credentials → triggers OTP
export const loginUser = async (email, password) => {
  try {
    const response = await axios.post(API_URL, { email, password });
    if (response.status === 200 && response.data.success) {
      return response.data; // OTP sent message
    } else {
      throw new Error(response.data.errorMessage || 'Failed to send OTP');
    }
  } catch (error) {
    if (error.response?.status === 503) {
      const message = error.response?.data?.errorMessage || '';
      const serviceMatch = message.match(/(Auth|User|Admin|Candidate|Employee) Service/);
      const service = serviceMatch ? serviceMatch[1].toLowerCase() : 'unknown';
      throw new Error(`ServiceDown:${service}`);
    }
    throw new Error(error.response?.data?.errorMessage || 'Login failed');
  }
};

// Step 2: Verify OTP → get tokens
export const verifyOtp = async (email, otp) => {
  try {
    const response = await axios.post(VERIFY_OTP_URL, null, {
      params: { email, otp },
    });
    if (response.status === 200 && response.data.success && response.data.data) {
      return {
        accessToken: response.data.data.accessToken,
        refreshToken: response.data.data.refreshToken,
        role: response.data.data.role,
      };
    } else {
      throw new Error(response.data.errorMessage || 'Invalid OTP');
    }
  } catch (error) {
    throw new Error(error.response?.data?.errorMessage || 'OTP verification failed');
  }
};

// Keep existing refresh & validate
export const refreshAccessToken = async (refreshToken) => {
  const response = await axios.post(REFRESH_URL, { refreshToken });
  if (response.status === 200 && response.data.data?.accessToken) {
    return { accessToken: response.data.data.accessToken };
  }
  throw new Error('Token refresh failed');
};

export const validateToken = async () => {
  const token = localStorage.getItem('bgc_token');
  if (!token) throw new Error('No token');
  const response = await axiosInstance.get(VALIDATE_URL, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data === true;
};